
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#407BFF"}}),_c('circle',{attrs:{"cx":"5","cy":"8","r":"1","fill":"#fff"}}),_c('circle',{attrs:{"cx":"8","cy":"8","r":"1","fill":"#fff"}}),_c('circle',{attrs:{"cx":"11","cy":"8","r":"1","fill":"#fff"}})])
          )
        }
      }
    